import React from 'react'
import VisitDetails46 from './46/VisitDetails'
import VisitDetails56 from './56/VisitDetails'
import VisitDetails57 from './57/VisitDetails'
import VisitDetails58 from './58/VisitDetails'
import VisitDetails61 from './61/VisitDetails'
import VisitDetails62 from './62/VisitDetails'

const VisitDetails = (props) => {

  return (
    <>
      {parseInt(process.env.REACT_APP_PROJECTID) === 46 ? <VisitDetails46 {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 56 ? <VisitDetails56 {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 57 ? <VisitDetails57 {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 58 ? <VisitDetails58 {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 61 ? <VisitDetails61 {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 62 ? <VisitDetails62 {...props} /> : null }
    </>
  )
}

export default VisitDetails